
import { defineComponent } from '@nuxtjs/composition-api';
import { CdnImg } from '@webplatform/cdn-image';

export default defineComponent({
  components: {
    CdnImg,
  },
  props: {
    country: {
      type: String,
      default: null,
    },
    city: {
      type: String,
      default: null,
    },
    image: {
      type: Object,
      default: null,
    },
    address: {
      type: String,
      default: null,
    },
    links: {
      type: Array,
      default: () => [],
    },
    emails: {
      type: Array,
      default: () => [],
    },
    phones: {
      type: Array,
      default: null,
    },
    fax: {
      type: String,
      default: null,
    },
    companyName: {
      type: String,
      default: null,
    },
  },
  setup() {
    const handleImageError = (event) => {
      // eslint-disable-next-line no-param-reassign
      event.target.src = '/images/image-placeholder.jpg';
    };
    return {
      handleImageError,
    };
  },
});
